// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader[data-v-9673f3ee]{align-items:center;animation:fade-in-background-9673f3ee 1s ease-in-out forwards;display:flex;height:100%;justify-content:center;left:0;position:fixed;top:0;width:100%;z-index:10}.loader__progress[data-v-9673f3ee]{animation:fade-in-9673f3ee 1s ease-in-out forwards}@keyframes fade-in-background-9673f3ee{0%{background:transparent}to{background:rgba(0,0,0,.6)}}@keyframes fade-in-9673f3ee{0%{opacity:0}to{opacity:1}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
